import styles from './LabelSelector.module.css'
import Select from 'react-select';

// Selettore del valore dell'etichetta
export default function LabelSelector({labels, label, selectLabel, resetPage}) {

    const mapListToOptions = (list) => {
        return list.map((element, i) => { return { value: element.toLowerCase(), label: element }});
    }

return (
    <div className={styles.labelSelection}>
        <label className={styles.controlPanelLabel}>Label</label>
        <Select
            className={styles.labelSelect}
            value={label} onChange={(e) => {
                selectLabel(e);
                resetPage({'label': e.value});
            }}
            options={mapListToOptions(labels)}
            theme={(theme) => ({
                ...theme,
                colors: {
                    ...theme.colors,
                    primary: 'var(--primary-color)',
                    primary75: 'var(--primary-color75)',
                    primary50: 'var(--primary-color50)',
                    primary25: 'var(--primary-color25)',
                    
                },
              })}/>
    </div>
);
}